import React, { useState } from "react";
import "./UiuxDesigns.scss";
import uiuxbanner from "../../../../Assets/Red_Theme/services/details/uiuxbanner.png";
import uiuxWebApplication from "../../../../Assets/Red_Theme/services/details/uiuxWebApplication.png";
import wireFraming from "../../../../Assets/Red_Theme/services/details/wireFraming.png";
import uiuxProcess from "../../../../Assets/Red_Theme/services/details/uiuxProcess.png";
import uiuxForMobileApps from "../../../../Assets/Red_Theme/services/details/uiuxForMobileApps.png";
import Lottie from "react-lottie";
import uidesign from "../../../../Assets/Red_Theme/lotin/uiux.json";
import UXStrategy from "../../../../Assets/Red_Theme/lotin/UXStrategy.json";
import productConceptualization from "../../../../Assets/Red_Theme/lotin/productConceptualization.json";
import { IoMdCheckboxOutline } from "react-icons/io";
import QuoteModal from "../../../../Components/QuoteModal";
import LetDiscuss from "../../../../Components/LetDiscuss";

function UiuxDesigns() {
  const uiux = {
    loop: true,
    autoplay: true,
    animationData: uidesign,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const uxstrategy = {
    loop: true,
    autoplay: true,
    animationData: UXStrategy,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const productconceptualization = {
    loop: true,
    autoplay: true,
    animationData: productConceptualization,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const [isOpen, setOpen] = useState(false);
  const [subject, setSubject] = useState(null);
  const OpenModal = (data) => {
    setSubject(data);
    setOpen(true);
  };
  return (
    <>
      <section className="uiuxViewService">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6" data-aos="fade-right">
              <div className="uiuxViewService_header_content">
                <h1>
                  UI/UX Design and Development <span>Services</span>
                </h1>
                <p>
                  Designing visually stunning, user-friendly, and
                  conversion-focused experiences to engage your audience and
                  turn visitors into loyal customers.
                </p>
                <button
                  className="theme_btn py-2"
                  onClick={() =>
                    OpenModal("UI/UX Design and Development Services")
                  }
                >
                  <span>Book Your Free Consultation & Get Started</span>
                </button>
              </div>
            </div>
            <div className="col-md-6" data-aos="fade-left">
              <img
                src={uiuxbanner}
                className="img-fluid"
                alt="uiuxbanner"
                title="uiuxbanner"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="secoundDiv">
        <div className="container">
          <div className="uiuxViewService_header_content">
            <h2>
              UI/UX Design and Development <span>Company</span>
            </h2>
            <p>
              A well-crafted user interface and seamless user experience are key
              drivers of engagement and sales growth. In today’s competitive
              digital landscape, aesthetics and functionality must work together
              to captivate users. User Experience (UX) and User Interface (UI)
              play a vital role in web applications, mobile app designs, and
              software development, ensuring a strong and lasting impact on your
              audience. A strategic and well-executed UI bridges the gap between
              business goals and user expectations, creating meaningful
              interactions.
            </p>
            <p>
              At Vidhan Infotech, we prioritize human-centered design to deliver
              outstanding digital experiences. By understanding user behavior,
              we craft intuitive, visually appealing, and easy-to-navigate
              interfaces that enhance satisfaction and usability. Our expert
              designers and developers collaborate closely to ensure a
              structured, efficient, and engaging UI/UX process. As your trusted
              design and development partner, we help you create simple,
              elegant, and impactful experiences that elevate your brand.
            </p>
          </div>
        </div>
      </section>
      <section className="thiredDiv">
        <div className="container">
          <div className="uiuxViewService_header_content">
            <h2 className="text-center">
              UI/UX Development <span>Offerings</span>
            </h2>
          </div>
          <div className="row contain">
            <div className="col-lg-4">
              <div className="box">
                <div className="top">
                  <div className="icon">
                    <Lottie options={uiux} />
                    {/* <img src={uiuxDesignIcon} className="img-fluid" alt="" /> */}
                  </div>
                  <h2>UI/UX Design Services</h2>
                </div>
                <p>
                  Our UI/UX designers work closely with you to develop
                  user-centric strategies, ensuring every step of the process is
                  executed flawlessly. With extensive experience in mobile apps,
                  web applications, and interactive interfaces, we focus on
                  crafting intuitive and engaging experiences that users truly
                  enjoy.
                </p>
                <span className="hover_effect"></span>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="box">
                <div className="top">
                  <div className="icon">
                    <Lottie options={productconceptualization} />
                    {/* <img src={productConceptualization} className="img-fluid" alt="" /> */}
                  </div>
                  <h2>Product Conceptualization</h2>
                </div>
                <p>
                  Product conceptualization is crucial for driving
                  organizational growth and success. We transform your vision
                  into a distinctive UX solution through strategic design and
                  innovation. Our expertise lies in delivering cutting-edge
                  solutions that enhance user engagement and support your
                  business development.
                </p>
                <span className="hover_effect"></span>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="box last">
                <div className="top">
                  <div className="icon">
                    <Lottie options={uxstrategy} />
                    {/* <img src={mdi_strategy} className="img-fluid" alt="" /> */}
                  </div>
                  <h2>UX Strategy</h2>
                </div>
                <p>
                  Whether it’s a website or a mobile app, our exceptional UX
                  expertise goes beyond prototypes to create seamless,
                  user-friendly experiences. Harness our UX strategy to
                  establish a compelling digital presence, fostering customer
                  loyalty and elevating your brand’s value.
                </p>
                <span className="hover_effect"></span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="fourDiv">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="uiuxViewService_header_content">
                <h2 className="text-center">
                  Wire <span>framing</span>
                </h2>
                <p>
                  Before bringing your product idea to life, we build a
                  structured and interactive framework to give you a clear
                  vision of the final outcome. By incorporating responsive
                  elements and essential components, we refine both web and
                  mobile experiences. Our iterative wireframing process ensures
                  continuous enhancement, leading to impactful and
                  results-driven solutions.
                </p>
              </div>
            </div>
            <div className="col-lg-6 mb-lg-0 mb-4">
              <img
                src={wireFraming}
                className="img-fluid"
                alt="wireFraming"
                title="wireFraming"
              />
            </div>
            <div className="col-lg-6">
              <div className="rightBoxes">
                <div className="box">
                  <h3>Visual Experience & Branding</h3>
                  <p>
                    We immerse ourselves in your vision, values, and goals to
                    craft a compelling brand identity that truly reflects your
                    business. Our skilled UX/UI designers specialize in building
                    cohesive and impactful visual experiences that set your
                    brand apart in a competitive landscape.
                  </p>
                </div>
                <div className="box">
                  <h3>Design Consultancy</h3>
                  <p>
                    The first impression your website makes in search results
                    plays a crucial role in user engagement. In today’s
                    fast-paced digital world, standing out is essential. We
                    offer expert digital consultancy services to craft
                    user-centric, intuitive, and responsive designs that elevate
                    the user experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="fiveDiv">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 mb-md-4 mb-0">
              <div className="uiuxViewService_header_content">
                <h2 className="text-center">
                  UI and UX <span>Process</span>
                </h2>
              </div>
            </div>
            <div className="col-md-4 leftSide">
              <ul>
                <li>1. Sketching and Wireframes</li>
                <li>2. Information Architecture</li>
                <li>3. Market Research and Analysis</li>
                <li>4. Design References</li>
                <li>5. Graphic Interface</li>
              </ul>
            </div>
            <div className="col-md-4">
              <img
                src={uiuxProcess}
                className="img-fluid"
                alt="uiuxProcess"
                title="uiuxProcess"
              />
            </div>
            <div className="col-md-4 rightSide">
              <ul>
                <li>6. Animation Prototype</li>
                <li>7. UI guidelines and kit</li>
                <li>8. Design Review</li>
                <li>9. User Interface Microinteractions</li>
                <li>10. Dynamic Prototype</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="sixDiv">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="uiuxViewService_header_content">
                <h2 className="text-center">
                  UI & UX Web <span>Applications</span>
                </h2>
                <p>
                  UX and UI are key to elevating user experience and
                  strengthening your brand’s presence. With the rise of global
                  internet usage, the web is now an integral part of every
                  marketing strategy. From SEO and online marketing to eCommerce
                  and social media, delivering an engaging web experience is
                  essential. That’s why we craft powerful web applications
                  backed by data-driven insights and expert design.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                src={uiuxWebApplication}
                className="img-fluid"
                alt="uiuxWebApplication"
                title="uiuxWebApplication"
              />
            </div>
            <div className="col-lg-6 rightSide">
              <ul>
                <li>
                  <IoMdCheckboxOutline />
                  Customer research
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  User Experience mapping
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  UX Experience with a UX audit
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Creating marketing Persons
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Information architecture
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Wireframing, Prototypes, Mockups
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Brand Style Guide
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Branding & identity
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Full-stack development
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Usability Testing for web application
                </li>
              </ul>
              <button
                className="theme_btn"
                onClick={() => OpenModal("Get Expert Advise")}
              >
                <span>get expert advise</span>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="sixDiv">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="uiuxViewService_header_content">
                <h2 className="text-center">
                  UI & UX for Mobile <span>Apps</span>
                </h2>
              </div>
            </div>
            <div className="col-md-6 leftSide">
              <img
                src={uiuxForMobileApps}
                className="img-fluid"
                alt="uiuxForMobileApps"
                title="uiuxForMobileApps"
              />
            </div>
            <div className="col-md-6 rightSide">
              <ul>
                <li>
                  <IoMdCheckboxOutline />
                  Customer research
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  User Experience mapping
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  UX Experience with a UX audit
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Creating marketing Persons
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Information architecture
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Wireframing, Prototypes, Mockups
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Brand Style Guide
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Branding & identity
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Full-stack development
                </li>
                <li>
                  <IoMdCheckboxOutline />
                  Usability Testing for web application
                </li>
              </ul>
              <button
                className="theme_btn"
                onClick={() => OpenModal("Get Expert Advise")}
              >
                <span>get expert advise</span>
              </button>
            </div>
          </div>
        </div>
      </section>
      <LetDiscuss />
      {isOpen && (
        <QuoteModal
          open={isOpen}
          setOpen={setOpen}
          CloseModal={() => setOpen(false)}
          subject={subject}
        />
      )}
    </>
  );
}
export default React.memo(UiuxDesigns);
